import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "../styles/EgitimStep.css";

const EgitimStep = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { egitimId } = useParams();

  const token = localStorage.getItem("token");
  const egitim = location.state?.egitim || null;

  const aktifEgitimId = egitim?.egitimId || egitimId;

  const [detay, setDetay] = useState(null);
  const [sayfalar, setSayfalar] = useState([]);
  const [aktifSayfa, setAktifSayfa] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hata, setHata] = useState("");
  const [medyaUrlMap, setMedyaUrlMap] = useState({});
  const [medyaLoadingMap, setMedyaLoadingMap] = useState({});
  const [baslayanSayfaMap, setBaslayanSayfaMap] = useState({});
  const videoMaxSureRef = useRef({});
  const [videoTamamlandiMap, setVideoTamamlandiMap] = useState({});
  const [tamamlananIcerikMap, setTamamlananIcerikMap] = useState({});
  const videoSeekingRef = useRef({});
  const videoLastTimeRef = useRef({});
  const videoProgressLastSaveRef = useRef({});
  const [showEgitimSonucPopup, setShowEgitimSonucPopup] = useState(false);
  const [egitimSonucMesaj, setEgitimSonucMesaj] = useState("");
  const stepBarRef = useRef(null);
  const stepRefs = useRef({});
  const [kalinanSinavIcerikMap, setKalinanSinavIcerikMap] = useState({});

  const [uyariMesaji, setUyariMesaji] = useState("");


  const getVideoStorageKey = (icerikId) => {
    return `egitimVideo_${aktifEgitimId}_${detay?.surec?.id}_${icerikId}`;
  };

  const videoSureKaydet = (icerikId, saniye) => {
    if (!icerikId || !detay?.surec?.id) return;

    localStorage.setItem(
      getVideoStorageKey(icerikId),
      String(Math.floor(saniye || 0))
    );
  };

  const videoSureOku = (icerikId) => {
    const value = localStorage.getItem(getVideoStorageKey(icerikId));
    const saniye = Number(value);

    return Number.isFinite(saniye) ? saniye : 0;
  };


  const fetchEgitimDetay = async () => {
    try {
      setLoading(true);
      setHata("");

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciEgitimleri/detay/${aktifEgitimId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = res.data;
      const sayfaListesi = data?.sayfalar?.$values || [];

      const siraliSayfalar = [...sayfaListesi].sort(
        (a, b) => a.siraNo - b.siraNo
      );

      const stateAktifSayfaId = location.state?.aktifSayfaId || location.state?.egitim?.aktifSayfaId;

      const aktif =
        siraliSayfalar.find((s) => s.id === Number(stateAktifSayfaId)) ||
        siraliSayfalar.find((s) => s.id === data?.surec?.aktifSayfaId) ||
        siraliSayfalar[0] ||
        null;

      setDetay(data);
      setSayfalar(siraliSayfalar);
      setAktifSayfa(aktif);
    } catch (err) {
      console.error("Eğitim detayı alınamadı:", err);
      setHata("Eğitim detayı yüklenirken sorun oluştu.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (aktifEgitimId && token) {
      fetchEgitimDetay();
    }
  }, [aktifEgitimId, token]);

  const getIcerikler = (sayfa) => {
    return sayfa?.icerikler?.$values || [];
  };

  const icerikTamamlandiMi = (icerik) => {
    return icerik.tamamlandiMi || tamamlananIcerikMap[icerik.id] === true;
  };

  const getSonrakiSayfaId = () => {
    if (!aktifSayfa) return null;

    const aktifIndex = sayfalar.findIndex((s) => s.id === aktifSayfa.id);
    const sonrakiSayfa = sayfalar[aktifIndex + 1];

    return sonrakiSayfa?.id || aktifSayfa.id;
  };

  const aktifSayfaIndex = sayfalar.findIndex((s) => s.id === aktifSayfa?.id);

  const sonSayfaMi = aktifSayfaIndex >= sayfalar.length - 1;

  const aktifSayfaVideolari = getIcerikler(aktifSayfa).filter(
    (icerik) => icerik.icerikTipi === "Video"
  );

  const aktifSayfaVideolariTamamlandi =
    aktifSayfaVideolari.length === 0 ||
    aktifSayfaVideolari.every(
      (icerik) => icerik.tamamlandiMi || videoTamamlandiMap[icerik.id]
    );


  const aktifSayfaAnketleri = getIcerikler(aktifSayfa).filter(
    (icerik) => icerik.icerikTipi === "Anket"
  );

  const aktifSayfaAnketleriTamamlandi =
    aktifSayfaAnketleri.length === 0 ||
    aktifSayfaAnketleri.every((icerik) => icerikTamamlandiMi(icerik));

  const aktifSayfaSinavlari = getIcerikler(aktifSayfa).filter(
    (icerik) => icerik.icerikTipi === "Sinav"
  );

  const aktifSayfaSinavlariTamamlandi =
    aktifSayfaSinavlari.length === 0 ||
    aktifSayfaSinavlari.every((icerik) => icerikTamamlandiMi(icerik));

  const aktifSayfaTamamlandi =
    aktifSayfaVideolariTamamlandi &&
    aktifSayfaAnketleriTamamlandi &&
    aktifSayfaSinavlariTamamlandi;

  const aktifSayfaEksikMesaj = !aktifSayfaVideolariTamamlandi
    ? "Videoyu Tamamlayın"
    : !aktifSayfaAnketleriTamamlandi
      ? "Anketi Tamamlayın"
      : !aktifSayfaSinavlariTamamlandi
        ? "Sınavı Tamamlayın"
        : "";

  const oncekiSayfayaGit = () => {
    if (aktifSayfaIndex > 0) {
      setAktifSayfa(sayfalar[aktifSayfaIndex - 1]);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const sonrakiSayfayaGit = async () => {
    try {
      setHata("");

      const icerikler = getIcerikler(aktifSayfa);


      for (const icerik of icerikler) {
        if (icerik.icerikTipi === "Video") continue;
        if (icerik.tamamlandiMi) continue;

        await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciEgitimleri/icerik-tamamla`,
          {
            modulEgitimKullaniciSurecId: detay?.surec?.id,
            modulEgitimIcerikId: icerik.id,
            gecenSureSaniye: 0,
            cevapMetni: "",
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciEgitimleri/sayfa-tamamla`,
        {
          modulEgitimKullaniciSurecId: detay?.surec?.id,
          modulEgitimSayfaId: aktifSayfa.id,
          gecenSureSaniye: 0,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSayfalar((prev) =>
        prev.map((sayfa) =>
          sayfa.id === aktifSayfa.id
            ? { ...sayfa, tamamlandiMi: true }
            : sayfa
        )
      );

      if (aktifSayfaIndex < sayfalar.length - 1) {
        setAktifSayfa(sayfalar[aktifSayfaIndex + 1]);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } catch (err) {
      console.error("İçerik / sayfa tamamlanamadı:", err);
      console.log("Sayfa tamamla backend response:", err.response?.data);

      setHata(
        err.response?.data?.message ||
        err.response?.data?.mesaj ||
        "İçerik tamamlanırken bir sorun oluştu."
      );

      throw err;
    }
  };

  const egitimiBitir = async () => {
    try {
      setHata("");

      await sonrakiSayfayaGit();

      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciEgitimleri/bitir/${aktifEgitimId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data?.success === false) {
        const eksikler = res.data?.eksikler?.$values || res.data?.eksikler || [];

        setHata(
          eksikler.length > 0
            ? eksikler.join(" | ")
            : res.data?.message || "Eğitim tamamlanamadı."
        );

        return;
      }

      setEgitimSonucMesaj(
        res.data?.message || "Eğitiminiz başarıyla tamamlandı."
      );
      setShowEgitimSonucPopup(true);
    } catch (err) {
      console.error("Eğitim bitirilemedi:", err);
      console.log("Eğitim bitir backend response:", err.response?.data);
      console.log(
        "Eğitim bitir eksikler:",
        err.response?.data?.eksikler?.$values || err.response?.data?.eksikler
      );

      const data = err.response?.data;
      const eksikler = data?.eksikler?.$values || data?.eksikler || [];

      setHata(
        Array.isArray(eksikler) && eksikler.length > 0
          ? eksikler.join(" | ")
          : data?.message ||
          data?.mesaj ||
          "Eğitim bitirilirken bir sorun oluştu."
      );
    }
  };

  const sayfaBaslat = async (sayfa) => {
    if (!sayfa?.id || !detay?.surec?.id) return;

    if (baslayanSayfaMap[sayfa.id]) return;

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciEgitimleri/sayfa-basla`,
        {
          modulEgitimKullaniciSurecId: detay.surec.id,
          modulEgitimSayfaId: sayfa.id,
          gecenSureSaniye: 0,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setBaslayanSayfaMap((prev) => ({
        ...prev,
        [sayfa.id]: true,
      }));
    } catch (err) {
      console.error("Sayfa başlatılamadı:", err);
    }
  };

  const videoIcerikTamamla = async (icerik, gecenSureSaniye = 0) => {
    if (!icerik?.id || !detay?.surec?.id) return;

    if (videoTamamlandiMap[icerik.id] || icerik.tamamlandiMi) return;

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciEgitimleri/icerik-tamamla`,
        {
          modulEgitimKullaniciSurecId: detay.surec.id,
          modulEgitimIcerikId: icerik.id,
          gecenSureSaniye: Math.floor(gecenSureSaniye || 0),
          cevapMetni: "Video tamamlandı",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setVideoTamamlandiMap((prev) => ({
        ...prev,
        [icerik.id]: true,
      }));
    } catch (err) {
      console.error("Video içeriği tamamlanamadı:", err);

      setHata(
        err.response?.data?.message ||
        err.response?.data?.mesaj ||
        "Video tamamlanırken bir sorun oluştu."
      );
    }
  };


  const videoIlerlemeKaydet = async (icerik, saniye) => {
    if (!icerik?.id || !detay?.surec?.id) return;
    if (icerik.tamamlandiMi || videoTamamlandiMap[icerik.id]) return;

    const temizSaniye = Math.floor(saniye || 0);
    if (temizSaniye < 3) return;

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciEgitimleri/icerik-tamamla`,
        {
          modulEgitimKullaniciSurecId: detay.surec.id,
          modulEgitimIcerikId: icerik.id,
          gecenSureSaniye: temizSaniye,
          cevapMetni: "Video ilerleme kaydı",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (err) {
      console.error("Video ilerleme kaydedilemedi:", err);
    }
  };

  const handleVideoTimeUpdate = (icerik, e) => {
    const video = e.currentTarget;
    const id = icerik.id;

    const currentTime = video.currentTime || 0;
    const maxTime = videoMaxSureRef.current[id] || 0;
    const lastTime = videoLastTimeRef.current[id] || 0;

    if (videoSeekingRef.current[id]) return;

    if (currentTime > maxTime + 1.2 && currentTime - lastTime > 2) {
      video.currentTime = maxTime;
      return;
    }

    if (currentTime > maxTime) {
      videoMaxSureRef.current[id] = currentTime;
    }

    videoLastTimeRef.current[id] = currentTime;

    const sonKayit = videoProgressLastSaveRef.current[id] || 0;

    if (currentTime - sonKayit >= 10) {
      videoProgressLastSaveRef.current[id] = currentTime;
      videoIlerlemeKaydet(icerik, currentTime);
    }
  };

  const handleVideoSeeking = (icerik, e) => {
    const video = e.currentTarget;
    const id = icerik.id;

    const maxTime = videoMaxSureRef.current[id] || 0;

    videoSeekingRef.current[id] = true;

    if (video.currentTime > maxTime + 0.5) {
      video.currentTime = maxTime;
    }
  };

  const handleVideoSeeked = (icerik, e) => {
    const video = e.currentTarget;
    const id = icerik.id;

    const maxTime = videoMaxSureRef.current[id] || 0;

    if (video.currentTime > maxTime + 0.5) {
      video.currentTime = maxTime;
    }

    videoLastTimeRef.current[id] = video.currentTime || 0;

    setTimeout(() => {
      videoSeekingRef.current[id] = false;
    }, 250);
  };

  const handleVideoEnded = (icerik, e) => {
    const video = e.currentTarget;
    const izlenenSure = video.duration || video.currentTime || 0;

    localStorage.removeItem(getVideoStorageKey(icerik.id));
    videoIcerikTamamla(icerik, izlenenSure);
  };

  const anketIcerikTamamla = async (icerikId) => {
    if (!icerikId || !detay?.surec?.id) return;

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciEgitimleri/icerik-tamamla`,
        {
          modulEgitimKullaniciSurecId: detay.surec.id,
          modulEgitimIcerikId: Number(icerikId),
          gecenSureSaniye: 0,
          cevapMetni: "Anket tamamlandı",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSayfalar((prev) =>
        prev.map((sayfa) => ({
          ...sayfa,
          icerikler: {
            ...sayfa.icerikler,
            $values: (sayfa.icerikler?.$values || []).map((icerik) =>
              icerik.id === Number(icerikId)
                ? { ...icerik, tamamlandiMi: true }
                : icerik
            ),
          },
        }))
      );

      setAktifSayfa((prev) => {
        if (!prev) return prev;

        return {
          ...prev,
          icerikler: {
            ...prev.icerikler,
            $values: (prev.icerikler?.$values || []).map((icerik) =>
              icerik.id === Number(icerikId)
                ? { ...icerik, tamamlandiMi: true }
                : icerik
            ),
          },
        };
      });
    } catch (err) {
      console.error("Anket içeriği tamamlanamadı:", err);
    }
  };


  useEffect(() => {
    const tamamlananIcerikId = location.state?.tamamlananIcerikId;

    if (tamamlananIcerikId) {
      setTamamlananIcerikMap((prev) => ({
        ...prev,
        [Number(tamamlananIcerikId)]: true,
      }));
    }

    if (tamamlananIcerikId && detay?.surec?.id) {
      anketIcerikTamamla(tamamlananIcerikId);
    }
  }, [location.state?.tamamlananIcerikId, detay?.surec?.id]);


  useEffect(() => {
    if (location.state?.sinavdanKaldi && location.state?.sinavIcerikId) {
      setKalinanSinavIcerikMap((prev) => ({
        ...prev,
        [Number(location.state.sinavIcerikId)]: true,
      }));
    }
  }, [location.state?.sinavdanKaldi, location.state?.sinavIcerikId]);

  useEffect(() => {
    if (location.state?.sinavdanKaldi) {
      setUyariMesaji(
        "Sınavdan geçemediğiniz için bu bölüm tamamlanmadı. Lütfen sınava tekrar giriniz."
      );
    }
  }, [location.state?.sinavdanKaldi]);

  useEffect(() => {
    const tamamlananSinavIcerikId = location.state?.tamamlananSinavIcerikId;

    if (tamamlananSinavIcerikId && detay?.surec?.id) {
      sinavIcerikTamamla(tamamlananSinavIcerikId);
    }
  }, [location.state?.tamamlananSinavIcerikId, detay?.surec?.id]);


  const sinavIcerikTamamla = async (icerikId) => {
    if (!icerikId || !detay?.surec?.id) return;

    const temizIcerikId = Number(icerikId);

    setTamamlananIcerikMap((prev) => ({
      ...prev,
      [temizIcerikId]: true,
    }));

    setKalinanSinavIcerikMap((prev) => {
      const yeni = { ...prev };
      delete yeni[temizIcerikId];
      return yeni;
    });

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciEgitimleri/icerik-tamamla`,
        {
          modulEgitimKullaniciSurecId: detay.surec.id,
          modulEgitimIcerikId: temizIcerikId,
          gecenSureSaniye: 0,
          cevapMetni: "Sınav tamamlandı",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSayfalar((prev) =>
        prev.map((sayfa) => ({
          ...sayfa,
          icerikler: {
            ...sayfa.icerikler,
            $values: (sayfa.icerikler?.$values || []).map((icerik) =>
              icerik.id === temizIcerikId
                ? { ...icerik, tamamlandiMi: true }
                : icerik
            ),
          },
        }))
      );

      setAktifSayfa((prev) => {
        if (!prev) return prev;

        return {
          ...prev,
          icerikler: {
            ...prev.icerikler,
            $values: (prev.icerikler?.$values || []).map((icerik) =>
              icerik.id === temizIcerikId
                ? { ...icerik, tamamlandiMi: true }
                : icerik
            ),
          },
        };
      });
    } catch (err) {
      console.error("Sınav içeriği tamamlanamadı:", err);
    }
  };


  const handleAnketBasla = async (icerik) => {
    try {
      setHata("");

      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciEgitimAnket/baslat`,
        {
          modulEgitimKullaniciSurecId: detay?.surec?.id,
          modulEgitimAnketId: icerik.modulEgitimAnketId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      navigate(`/personel/anket/${icerik.modulEgitimAnketId}`, {
        state: {
          fromEgitim: true,
          egitimId: aktifEgitimId,
          aktifSayfaId: aktifSayfa.id,
          sonrakiSayfaId: getSonrakiSayfaId(),
          surecId: detay?.surec?.id,
          icerikId: icerik.id,
          modulEgitimAnketId: icerik.modulEgitimAnketId,
        },
      });
    } catch (err) {
      console.error("Anket başlatılamadı:", err);

      setHata(
        err.response?.data?.message ||
        err.response?.data?.mesaj ||
        "Anket başlatılırken bir sorun oluştu."
      );
    }
  };

  const handleSinavBasla = async (icerik) => {
    try {
      setHata("");

      const sinavId =
        icerik.sinavBilgisi?.sinavId ||
        icerik.sinavId ||
        icerik.modulEgitimSinavBaglanti?.sinavId;

      if (!sinavId) {
        setHata("Sınav bilgisi bulunamadı.");
        return;
      }

      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciSinav/baslat`,
        {
          sinavId: sinavId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const kullaniciSinavId =
        res.data?.kullaniciSinavId ||
        res.data?.data?.kullaniciSinavId;

      if (!kullaniciSinavId) {
        console.error("kullaniciSinavId bulunamadı:", res.data);
        setHata("Sınav başlatıldı fakat sınav oturumu alınamadı.");
        return;
      }

      const soruIdleri =
        res.data?.randomSoruIcerikIdleri?.$values ||
        res.data?.data?.randomSoruIcerikIdleri?.$values ||
        res.data?.soruIdleri?.$values ||
        res.data?.data?.soruIdleri?.$values ||
        [];

      const sinavState = {
        fromEgitim: true,
        egitimId: aktifEgitimId,
        aktifSayfaId: aktifSayfa.id,
        surecId: detay?.surec?.id,
        icerikId: icerik.id,

        sinavBaslik:
          icerik.sinavBilgisi?.baslik ||
          icerik.sinavBilgisi?.baglantiTipi ||
          icerik.baslik ||
          "Sınav",

        sinavId,
        kullaniciSinavId,
        toplamSoru: res.data?.toplamSoru || res.data?.data?.toplamSoru,
        kalanSureSaniye:
          res.data?.kalanSureSaniye || res.data?.data?.kalanSureSaniye,
        ilkSiraNo: res.data?.ilkSiraNo || res.data?.data?.ilkSiraNo || 1,
        soruIdleri,
      };

      sessionStorage.setItem(
        `sinavState_${kullaniciSinavId}`,
        JSON.stringify(sinavState)
      );

      navigate(`/personel/sinav/${kullaniciSinavId}`, {
        state: sinavState,
      });
    } catch (err) {
      console.error("Sınav başlatılamadı:", err);

      setHata(
        err.response?.data?.message ||
        err.response?.data?.mesaj ||
        "Sınav başlatılırken bir sorun oluştu."
      );
    }
  };

  const getFullUrl = (url) => {
    if (!url) return "";

    if (url.startsWith("http://") || url.startsWith("https://")) {
      return url;
    }

    return `${process.env.REACT_APP_API_BASE_URL}${url}`;
  };

  const medyaGetir = async (icerik) => {
    if (!icerik?.id) return;

    if (medyaUrlMap[icerik.id] || medyaLoadingMap[icerik.id]) return;

    try {
      setMedyaLoadingMap((prev) => ({
        ...prev,
        [icerik.id]: true,
      }));

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciEgitimleri/medya/${icerik.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        }
      );

      const blobUrl = URL.createObjectURL(res.data);

      setMedyaUrlMap((prev) => ({
        ...prev,
        [icerik.id]: blobUrl,
      }));
    } catch (err) {
      console.error("Medya alınamadı:", icerik.id, err);
    } finally {
      setMedyaLoadingMap((prev) => ({
        ...prev,
        [icerik.id]: false,
      }));
    }
  };

  useEffect(() => {
    if (!aktifSayfa) return;

    const icerikler = getIcerikler(aktifSayfa);

    icerikler.forEach((icerik) => {
      if (icerik.icerikTipi === "Resim" || icerik.icerikTipi === "Video") {
        medyaGetir(icerik);
      }
    });
  }, [aktifSayfa]);

  useEffect(() => {
    if (aktifSayfa && detay?.surec?.id) {
      sayfaBaslat(aktifSayfa);
    }
  }, [aktifSayfa, detay?.surec?.id]);

  useEffect(() => {
    if (!aktifSayfa?.id) return;

    const aktifStep = stepRefs.current[aktifSayfa.id];

    if (aktifStep) {
      aktifStep.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [aktifSayfa?.id]);

  const handleClose = () => {
    navigate("/profil");
  };

  if (hata) {
    return (
      <div className="egitim-step-page">
        <div className="egitim-error-card">
          <button className="egitim-step-close" onClick={handleClose}>
            ✖
          </button>

          <div className="egitim-error-icon">!</div>

          <h2>Bir sorun oluştu</h2>

          <p>{hata}</p>

          <button className="egitim-error-btn" onClick={handleClose}>
            Eğitimlere Dön
          </button>
        </div>
      </div>
    );
  }

  if (!detay || !aktifSayfa) {
    return (
      <div className="egitim-step-page">
        <div className="egitim-error-card">
          <button className="egitim-step-close" onClick={handleClose}>
            ✖
          </button>

          <div className="egitim-error-icon">!</div>

          <h2>Eğitim detayı bulunamadı</h2>

          <p>Bu eğitime ait içerik yüklenemedi. Lütfen tekrar deneyiniz.</p>

          <button className="egitim-error-btn" onClick={handleClose}>
            Eğitimlere Dön
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="egitim-step-page">
      <div className="egitim-step-container">
        <button className="egitim-step-close" onClick={handleClose}>
          ✖
        </button>

        <div className="egitim-egitim-header">
          <h1>{detay.egitim?.baslik}</h1>

          <p>
            {sayfalar.length} Bölüm •{" "}
            {detay.egitim?.tahminiSureDakika || 0} Dakika
          </p>
        </div>

        <div className="egitim-step-bar" ref={stepBarRef}>
          {sayfalar.map((sayfa) => (
            <div
              key={sayfa.id}
              ref={(el) => {
                stepRefs.current[sayfa.id] = el;
              }}
              className={`step-box ${aktifSayfa.id === sayfa.id ? "aktif" : ""
                } ${sayfa.tamamlandiMi ? "tamamlandi" : ""}`}
            >
              {sayfa.baslik}
            </div>
          ))}
        </div>

        {uyariMesaji && (
          <div className="egitim-bilgi-kutusu">
            {uyariMesaji}
          </div>
        )}

        <div className="egitim-step-content">
          <h3>{aktifSayfa.baslik}</h3>

          {aktifSayfa.aciklama && <p>{aktifSayfa.aciklama}</p>}

          {getIcerikler(aktifSayfa).map((icerik) => (
            <div key={icerik.id} className="egitim-icerik-box">


              {icerik.icerikTipi === "Yazi" && (
                <div
                  className="egitim-yazi-icerik"
                  dangerouslySetInnerHTML={{
                    __html: icerik.metin || "",
                  }}
                />
              )}

              {icerik.icerikTipi === "Resim" && (
                <>
                  {medyaUrlMap[icerik.id] ? (
                    <img
                      src={medyaUrlMap[icerik.id]}
                      alt="Eğitim İçeriği"
                      className="egitim-resim-icerik"
                    />
                  ) : (
                    <p>Resim yükleniyor...</p>
                  )}
                </>
              )}

              {icerik.icerikTipi === "Video" && (
                <>
                  {medyaUrlMap[icerik.id] ? (
                    <video
                      width="100%"
                      controls
                      controlsList="nodownload"
                      disablePictureInPicture
                      playsInline
                      preload="metadata"
                      className="egitim-video-icerik"
                      src={medyaUrlMap[icerik.id]}
                      onLoadedMetadata={(e) => {
                        const video = e.currentTarget;
                        const kayitliSure = Number(icerik.gecenSureSaniye || 0);

                        if (kayitliSure > 3 && kayitliSure < video.duration - 3) {
                          video.currentTime = kayitliSure;
                          videoMaxSureRef.current[icerik.id] = kayitliSure;
                          videoLastTimeRef.current[icerik.id] = kayitliSure;
                          videoProgressLastSaveRef.current[icerik.id] = kayitliSure;
                        }
                      }}
                      onContextMenu={(e) => e.preventDefault()}
                      onKeyDown={(e) => e.preventDefault()}
                      onTimeUpdate={(e) => handleVideoTimeUpdate(icerik, e)}
                      onSeeking={(e) => handleVideoSeeking(icerik, e)}
                      onSeeked={(e) => handleVideoSeeked(icerik, e)}
                      onEnded={(e) => handleVideoEnded(icerik, e)}
                    >
                      Tarayıcınız video oynatmayı desteklemiyor.
                    </video>
                  ) : (
                    <p>Video yükleniyor...</p>
                  )}
                </>
              )}


              {icerik.icerikTipi === "Anket" && (
                <button
                  className="egitim-action-btn"
                  onClick={() => handleAnketBasla(icerik)}
                  disabled={icerikTamamlandiMi(icerik)}
                >
                  {icerikTamamlandiMi(icerik) ? "Anket Tamamlandı" : "Ankete Başla"}
                </button>
              )}

              {icerik.icerikTipi === "Sinav" && (
                <div className="egitim-sinav-kutusu">
                  <div className="egitim-bilgi-kutusu">
                    Bu bölümde tamamlamanız gereken bir sınav bulunmaktadır.
                  </div>

                  <button
                    className="egitim-action-btn"
                    onClick={() => handleSinavBasla(icerik)}
                    disabled={icerikTamamlandiMi(icerik)}
                  >
                    {icerikTamamlandiMi(icerik)
                      ? "Sınav Tamamlandı"
                      : kalinanSinavIcerikMap[icerik.id]
                        ? "Tekrar Sınava Gir"
                        : "Sınava Başla"}
                  </button>
                </div>
              )}


              {icerik.icerikTipi === "Dosya" && (
                <button
                  className="egitim-action-btn"
                  onClick={() =>
                    window.open(getFullUrl(icerik.dosyaUrl), "_blank")
                  }
                >
                  Dosyayı Görüntüle
                </button>
              )}

              {icerik.icerikTipi === "Link" && (
                <button
                  className="egitim-action-btn"
                  onClick={() => window.open(icerik.linkUrl, "_blank")}
                >
                  Linki Aç
                </button>
              )}
            </div>
          ))}
        </div>

        <div className="egitim-page-actions">
          <button
            className="egitim-page-nav-btn secondary"
            onClick={oncekiSayfayaGit}
            disabled={aktifSayfaIndex <= 0}
          >
            ← Geri
          </button>

          {sonSayfaMi ? (
            <button
              className="egitim-page-nav-btn"
              onClick={egitimiBitir}
              disabled={!aktifSayfaTamamlandi}
            >
              {aktifSayfaTamamlandi
                ? "Eğitimi Bitir"
                : aktifSayfaEksikMesaj}
            </button>
          ) : (
            <button
              className="egitim-page-nav-btn"
              onClick={sonrakiSayfayaGit}
              disabled={!aktifSayfaTamamlandi}
            >
              {aktifSayfaTamamlandi
                ? "İleri →"
                : aktifSayfaEksikMesaj}
            </button>
          )}
        </div>
      </div>

      {showEgitimSonucPopup && (
        <div className="egitim-sonuc-overlay">
          <div className="egitim-sonuc-popup">
            <div className="egitim-sonuc-icon">✓</div>

            <h2>Eğitim Tamamlandı</h2>

            <p>{egitimSonucMesaj}</p>

            <button
              onClick={() => {
                setShowEgitimSonucPopup(false);
                navigate("/profil", { replace: true });
              }}
            >
              Tamam
            </button>
          </div>
        </div>
      )}


    </div>
  );
};

export default EgitimStep;